<template>
    <main id="mainCtrl">
        <DoctorConfirmDialog ref="doctorConfirmDialog" @updated="updateTable"/>

        <v-table id="doctorsConfirmTable"
                 request-uri="doctorsConfirm/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="city">
                        Город
                    </v-th>
                    <v-th name="created_at" sort="created_at" width="100">
                        Создан
                    </v-th>
                    <v-th name="username" sort="username" minwidth="150">
                        ФИО
                    </v-th>
                    <v-th name="speciality" width="150">
                        Специализация
                    </v-th>
                    <v-th name="email" sort="email" minwidth="150">
                        Email
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Телефон
                    </v-th>
                    <v-th name="experience" width="50">
                        Стаж
                    </v-th>
                    <v-th name="workPlace">
                        Место работы
                    </v-th>
                    <v-th name="doctu_url" sort="doctu_url" minwidth="150">
                        Url
                    </v-th>
                    <v-th name="status" sort="status" width="100">
                        Подтверждён
                    </v-th>
                    <v-th name="cancelReason" width="100">
                        Причина отклонения
                    </v-th>
                    <v-th name="rating_notifications" sort="rating_notifications" width="50" v-tooltip="'Уведомления о отзыве'">
                        Отз
                    </v-th>
                    <v-th name="question_free_notifications" sort="question_free_notifications" width="50" v-tooltip="'Уведомления о бесплатных вопросах'">
                        БПлат
                    </v-th>
                    <v-th name="question_payable_notifications" sort="question_payable_notifications" width="50" v-tooltip="'Уведомления о платных вопросах'">
                        Плат
                    </v-th>
                    <v-th name="question_individual_notifications" sort="question_individual_notifications" width="50" v-tooltip="'Уведомления об индивидуальных консультациях'">
                        Конс
                    </v-th>
                    <v-th name="question_answers_notifications" sort="question_answers_notifications" width="50" v-tooltip="'Уведомления об ответах'">
                        Отв
                    </v-th>
                    <v-th name="verification_notifications" sort="verification_notifications" width="50" v-tooltip="'Уведомления о верификации'">
                        Вер
                    </v-th>
                    <v-th name="payments_notifications" sort="payments_notifications" width="50" v-tooltip="'Уведомления о выплатах'">
                        Выпл
                    </v-th>
                    <v-th name="appreciations_notifications" sort="appreciations_notifications" width="50" v-tooltip="'Уведомления о вознаграждениях'">
                        Возн
                    </v-th>
                    <v-th name="acknowledgments_notifications" sort="acknowledgments_notifications" width="50" v-tooltip="'Уведомления о благодарностях'">
                        Благ
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="city"/>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="username" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="speciality"/>
                    <v-th name="email" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="experience"/>
                    <v-th name="workPlace"/>
                    <v-th name="doctu_url" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '20', text: 'Новый' },
                                { value: '10', text: 'Подтвержден' },
                                { value: '30', text: 'Отклонено' },
                            ]"
                        />
                    </v-th>
                    <v-th name="cancelReason"/>
                    <v-th name="rating_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="question_free_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="question_payable_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="question_individual_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="question_answers_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="verification_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="payments_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="appreciations_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                    <v-th name="acknowledgments_notifications" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Есть' },
                                { value: '0', text: 'Нет' },
                            ]"
                        />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                      :id="'dc-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="city">
                        {{ item.city ? item.city.name : '' }}
                    </v-td>
                    <v-td name="created_at"  highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="username">
                        {{ item.username }}
                    </v-td>
                    <v-td name="speciality">
                        {{ item.doctor ? item.doctor.specialitiesAsText : '' }}
                    </v-td>
                    <v-td name="email">
                        {{ item.email }}
                    </v-td>
                    <v-td name="phone">
                        {{ item.phone }}
                    </v-td>
                    <v-td name="experience">
                        {{ item.user_info ? item.user_info.experience : '' }}
                    </v-td>
                    <v-td name="workPlace">
                        {{ item.user_info ? item.user_info.workPlace : '' }}
                    </v-td>
                    <v-td name="doctu_url">
                        {{ item.doctu_url }}
                    </v-td>
                    <v-td name="status" align="center">
                        <span v-if="item.status === 30">Отклонено</span>
                        <span v-if="item.status === 20" class="label bg-red">Новый</span>
                        <span v-if="item.status === 10">Подтвержден</span>
                        <span v-if="item.status === 0">Удален</span>
                    </v-td>
                    <v-td name="cancelReason">
                        {{ item.params ? item.params.cancelReason : '' }}
                    </v-td>
                    <v-td name="rating_notifications" align="center">
                        <span v-if="item.rating_notifications">есть</span>
                        <span v-if="!item.rating_notifications">нет</span>
                    </v-td>
                    <v-td name="question_free_notifications" align="center">
                        <span v-if="item.question_free_notifications">есть</span>
                        <span v-if="!item.question_free_notifications">нет</span>
                    </v-td>
                    <v-td name="question_payable_notifications" align="center">
                        <span v-if="item.question_payable_notifications">есть</span>
                        <span v-if="!item.question_payable_notifications">нет</span>
                    </v-td>
                    <v-td name="question_individual_notifications" align="center">
                        <span v-if="item.question_individual_notifications">есть</span>
                        <span v-if="!item.question_individual_notifications">нет</span>
                    </v-td>
                    <v-td name="question_answers_notifications" align="center">
                        <span v-if="item.question_answers_notifications">есть</span>
                        <span v-if="!item.question_answers_notifications">нет</span>
                    </v-td>
                    <v-td name="verification_notifications" align="center">
                        <span v-if="item.verification_notifications">есть</span>
                        <span v-if="!item.verification_notifications">нет</span>
                    </v-td>
                    <v-td name="payments_notifications" align="center">
                        <span v-if="item.payments_notifications">есть</span>
                        <span v-if="!item.payments_notifications">нет</span>
                    </v-td>
                    <v-td name="appreciations_notifications" align="center">
                        <span v-if="item.appreciations_notifications">есть</span>
                        <span v-if="!item.appreciations_notifications">нет</span>
                    </v-td>
                    <v-td name="acknowledgments_notifications" align="center">
                        <span v-if="item.acknowledgments_notifications">есть</span>
                        <span v-if="!item.acknowledgments_notifications">нет</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import DoctorConfirmDialog from "@dialogs/doctorsConfirm/DoctorConfirmDialog";

export default {
    components: {DoctorConfirmDialog},
    methods: {
        handleRowClick(event, item, row) {
            row.startLoadingAnimation();

            this.$refs.doctorConfirmDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },

        updateTable() {
            this.$refs.table.update();
            this.$bus.fire('updateMenu');
        }
    },
}
</script>
